import { render, staticRenderFns } from "./biz.vue?vue&type=template&id=03beac10&scoped=true&lang=pug&"
import script from "./biz.vue?vue&type=script&lang=js&"
export * from "./biz.vue?vue&type=script&lang=js&"
import style0 from "./biz.vue?vue&type=style&index=0&id=03beac10&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03beac10",
  null
  
)

export default component.exports